import { Chip } from '@mui/material'
import RedFlagIcon from './icons/RedFlagIcon'
import { colors, fontSizes, fontWeights, borderRadius } from '@/theme'

export default function RedFlagChip() {
  return (
    <Chip
      icon={<RedFlagIcon />}
      label='Red flag'
      size='small'
      sx={{
        px: 1,
        py: 0.5,
        height: '24px',
        bgcolor: colors.status.errorLight,
        color: colors.status.error,
        border: `1px solid ${colors.status.error}`,
        borderRadius: borderRadius.lg,
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.bold,
        '& .MuiChip-label': {
          p: 0,
          ml: 0.5
        },
        '& .MuiChip-icon': {
          ml: 0,
          mr: 0
        }
      }}
    />
  )
}
